import React from 'react';
import BootstrapTable, { ColumnDescription, ExpandRowProps, SortOrder, TableChangeHandler, TableChangeState, TableChangeType, BootstrapTableProps } from 'react-bootstrap-table-next';
import ToolkitProvider, { CSVExport, Search } from 'react-bootstrap-table2-toolkit';
import paginationFactory from 'react-bootstrap-table2-paginator';

import { Loading } from './visuals/Visuals';

interface Props {
    keyField: string,
    data: any[],
    columns: ColumnDescription<any, any>[],
    mobileColumns?: ColumnDescription<any, any>[],
    loading: Boolean
    menuField?: JSX.Element[],
    searchPlaceholder?: string,
    searchHidden?: boolean,
    emptyTableText?: string,
    pageSize?: number,
    bsTableProps?: {
        filter?: any,
        rowEvents?: any
        rowStyle?: React.CSSProperties | ((row: any, rowIndex: number) => React.CSSProperties)
        defaultSorted?: [{dataField: any, order: SortOrder}],
        headerClasses?: string,
        remote?:
            | boolean
            | Partial<{ pagination: boolean; filter: boolean; sort: boolean; cellEdit: boolean; search: boolean }>,
        onTableChange?: TableChangeHandler<any>,
        expandRow?: ExpandRowProps<any, number>,
        rowClasses?: string
    },
    csvExport?: boolean,
    pageOptions?: {
        sizePerPage?: number,
        pageStartIndex: number,
        paginationSize: number,
        sizePerPageList: { text: string, value: number }[]
    }
}

interface State { window_width: number, window_height: number, pageSize: number }

const { SearchBar } = Search;
const { ExportCSVButton } = CSVExport;

export default class Table extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        
        this.noDataIndicator = this.noDataIndicator.bind(this);
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);

        this.state = {
            window_width: 0,
            window_height: 0,
            pageSize: props.pageSize || -1
        }
    }

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions() {
        this.setState({window_width: window.innerWidth, window_height: window.innerHeight});
    }

    noDataIndicator() {
        const { loading, emptyTableText } = this.props

        if(loading) {
            return (<div style={{padding: '1rem'}}>
                <Loading>
                    {"Hämtar data..."}
                </Loading>
            </div>);
        }
        else {
            return <div style={{padding: '1rem', fontSize: '1.5rem'}}>
                {emptyTableText || "Ingen data"}
            </div>;
        }
    }

    render() {
        const { keyField, columns, mobileColumns, data, menuField, searchPlaceholder, searchHidden, bsTableProps, pageOptions } = this.props
        const { window_width, pageSize } = this.state
        
        //Picks the appropriate columntemplate for the current screensize.
        const activeColumns = mobileColumns != undefined && window_width <= 640 ?
                                mobileColumns
                              : columns;

        
        const hidePageSizePicker = pageOptions == undefined;

        return (<div className={`render-table ${hidePageSizePicker ? 'render-table-hide-page-size-picker': ''}`}>
            <ToolkitProvider
                keyField={ keyField } 
                columns={ activeColumns } 
                data={ this.props.data }
                search
                exportCSV
            >
                { props => {
                    const baseProps = searchHidden ? 
                        {...{ data: props.baseProps.data, columns: props.baseProps.columns, keyField: props.baseProps.keyField }} 
                        : {...props.baseProps};

                    return ( <div>
                        { searchHidden ? null
                            : <SearchBar 
                                {...props.searchProps } 
                                placeholder={searchPlaceholder || "Sök"}
                            />
                        }
                        { 
                            menuField !== undefined ? 
                                <div style={{display:'inline'}}>{ menuField }</div>
                            : null
                        }
                        <BootstrapTable 
                            { ...props.baseProps } 
                            noDataIndication={ this.noDataIndicator }
                            {...bsTableProps}
                            pagination={ pageOptions ? paginationFactory({alwaysShowAllBtns: true, ...pageOptions}) : pageSize > 0 ? paginationFactory({sizePerPage: pageSize}) : undefined }
                        />
                    </div> );
                }}
            </ToolkitProvider>
        </div>);
    }
}